var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: { visible: "", width: "42%", title: "" },
      on: { close: _vm.onCancel },
    },
    [
      _c("div", { staticClass: "flex" }, [
        _c("img", {
          staticClass: "authorise-icon",
          attrs: { src: require("@/assets/img/Important.png") },
        }),
        _c("div", { staticClass: "flex-1 custom-pwd-info" }, [
          _c("p", { staticClass: "authorise-title" }, [
            _vm._v(_vm._s(_vm.$t("pdwComplexity.important"))),
          ]),
          _c("p", {
            staticClass: "policy-tips",
            domProps: { innerHTML: _vm._s(_vm.$t("pdwComplexity.tips")) },
          }),
        ]),
      ]),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "div",
            {
              staticClass: "btn-ok",
              attrs: { type: "primary" },
              on: { click: _vm.onConfirm },
            },
            [
              _c("p", [_vm._v(_vm._s(_vm.$t("pdwComplexity.ok")))]),
              _c("p", { staticClass: "mt-10 tips" }, [
                _vm._v(_vm._s(_vm.$t("pdwComplexity.okTips"))),
              ]),
            ]
          ),
          _c("div", { staticClass: "btn-no", on: { click: _vm.onNoConfirm } }, [
            _c("p", [_vm._v(_vm._s(_vm.$t("pdwComplexity.noted")))]),
            _c("p", { staticClass: "mt-10 tips" }, [
              _vm._v(_vm._s(_vm.$t("pdwComplexity.notedTips"))),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }